import { useMemo, useState } from 'react';
import { useMaterialReactTable, MRT_TableContainer } from 'material-react-table';
import { TextField, IconButton } from '@mui/material';
import EditIcon from '@mui/icons-material/Edit';

const LongTermDragabble = ({ motivators, setMotivators }) => {
  const [pageIndex, setPageIndex] = useState(0);  // Track the current page
  const [pageSize, setPageSize] = useState(5);    // Set the number of rows per page (5 rows per page)
  const [editingIndex, setEditingIndex] = useState(null); // Track the row being edited
  const [editedTitle, setEditedTitle] = useState(''); // Track the edited title

  const columns = useMemo(
    () => [
      {
        accessorKey: 'index',
        header: 'Index',
        size: 20,
        muiTableHeadCellProps: {
          style: {
            width: '20px',
            textAlign: 'center',
          },
        },
        muiTableCellProps: {
          style: {
            maxWidth: '30px',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap',
            textAlign: 'center',
          },
        },
      },
      {
        accessorKey: 'status',
        header: '#',
        size: 100,
        muiTableHeadCellProps: {
          style: {
            width: '150px',
          },
        },
        muiTableCellProps: {
          style: {
            maxWidth: '150px',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap',
          },
        },
      },
      {
        accessorKey: 'title',
        header: 'Title',
        size: 100,
        muiTableHeadCellProps: {
          style: {
            width: '1650px',
          },
        },
        muiTableCellProps: {
          style: {
            maxWidth: '1650px',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap',
            display: 'flex',
            alignItems: 'center',
          },
          // Rendering editable title with TextField on click
        //   renderCell: ({ rowIndex }) => {

        //     console.log("vfmkg", rowIndex)
        //     const motivator = motivators[rowIndex];
        //     return editingIndex === rowIndex ? (
        //       <TextField
        //         value={editedTitle}
        //         onChange={(e) => setEditedTitle(e.target.value)}
        //         onBlur={() => saveTitle(rowIndex)}
        //         onKeyDown={(e) => {
        //           if (e.key === 'Enter') saveTitle(rowIndex);
        //         }}
        //         autoFocus
        //         size="small"
        //         fullWidth
        //       />
        //     ) : (
        //       <div style={{ display: 'flex', alignItems: 'center' }}>
        //         <span style={{ flex: 1 }}>{motivator.title}</span>
        //         <IconButton
        //           onClick={() => startEditing(rowIndex, motivator.title)}
        //           size="small"
        //           sx={{ marginLeft: 1 }} // Small margin to the left of the title
        //         >
        //           <EditIcon />
        //         </IconButton>
        //       </div>
        //     );
        //   },
        },
      },
    ],
    [editingIndex, editedTitle, motivators]
  );

  const saveTitle = (rowIndex) => {
    const newMotivators = [...motivators];
    newMotivators[rowIndex] = { ...newMotivators[rowIndex], title: editedTitle };
    setMotivators(newMotivators);
    setEditingIndex(null); // Stop editing when the title is saved
  };

  const startEditing = (rowIndex, currentTitle) => {
    setEditingIndex(rowIndex);
    setEditedTitle(currentTitle); // Set the current title for editing
  };

  const dataWithIndex = motivators
    .slice(pageIndex * pageSize, (pageIndex + 1) * pageSize)
    .map((motivator, index) => ({
      ...motivator,
      index: pageIndex * pageSize + index + 1,
    }));

  const table = useMaterialReactTable({
    autoResetPageIndex: false,
    columns,
    data: dataWithIndex,
    enableRowOrdering: true,
    enableSorting: false,
    pagination: true,
    state: {
      pageIndex,
      pageSize,
    },
    onPaginationChange: (updater) => {
      const newState = updater({ pageIndex, pageSize });
      setPageIndex(newState.pageIndex);
      setPageSize(newState.pageSize);
    },
    muiRowDragHandleProps: ({ table }) => ({
      onDragEnd: () => {
        const { draggingRow, hoveredRow } = table.getState();
        if (hoveredRow && draggingRow) {
          const newMotivators = [...motivators];
          newMotivators.splice(
            hoveredRow.index,
            0,
            newMotivators.splice(draggingRow.index, 1)[0]
          );
          setMotivators(newMotivators);
        }
      },
    }),
  });

  return (
    <div>
      <MRT_TableContainer table={table} />
      <div style={{ marginTop: 10 }}>
        <button onClick={() => setPageIndex((prev) => Math.max(0, prev - 1))}>
          Previous
        </button>
        <span> Page {pageIndex + 1} </span>
        <button onClick={() => setPageIndex((prev) => prev + 1)}>
          Next
        </button>
      </div>
    </div>
  );
};

export default LongTermDragabble;
